import React, { Component } from 'react'

import debounce from 'lodash/debounce'
import Autosuggest from 'react-autosuggest'

import InfoButton from '../buttons/InfoButton'
import withAutocomplete from '../../../utils/graphql/hocs/withAutocomplete'
import get from 'lodash/get'
class SearchBoxWithSuggestions extends Component {
  constructor() {
    super()

    this.state = {
      value: '',
    }

    this.escapeRegexCharacters = str => (str ? str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '')

    this.onSuggestionsFetchRequested = async ({ value }) => {
      const {
        meta: { error },
      } = this.props
      if (error) return

      const { getAutocompleteResults, field } = this.props
      await getAutocompleteResults({ prefix: value, field })
    }

    this.fetchSuggestionsWithDebounce = debounce(this.onSuggestionsFetchRequested, 500)

    this.onChange = (event, { newValue }) => {
      this.props.input.onChange(newValue)
      this.setState({ value: newValue })
    }

    this.renderSectionTitle = section => <strong>{section.title}</strong>

    this.getSectionSuggestions = section => section.suggestions

    this.getSuggestionValue = suggestion => suggestion.name

    this.renderSuggestion = suggestion => <span>{suggestion.name}</span>

    this.handleSelection = (
      event,
      { suggestion, suggestionValue, suggestionIndex, sectionIndex, method },
    ) => {
      this.setState({ value: suggestionValue })
      this.props.onSuggestionSelected(suggestionValue)
    }
  }

  componentDidUpdate(prevProps) {
    const formValue = get(this.props, 'input.value')
    const prevValue = get(prevProps, 'input.value')
    if(formValue !== prevValue && !formValue) {
      this.setState({ value: '' })
    }
  }

  render() {
    const {
      className,
      input,
      isPerformingSearch = false,
      placeholder,
      label,
      meta: { touched, error },
      search = true,
      tipContent,
    } = this.props
    const { value } = this.state

    const inputProps = {
      className: `react-autosuggest__input react-autosuggest__input--open react-autosuggest__input--focused ${className} border-radius3`,
      onChange: this.onChange,
      placeholder,
      value: value|| input.value,
    }

    const { onBlur } = input

    return (
      <div
        id="renderSearchBoxWithSuggestions"
        style={{ paddingTop: 10 }}
        onClick={() => {
          onBlur()
        }}
      >
        {label && (
          <div>
            <label>{label}</label>
            <span className="pull-right" style={{ color: '#808080' }}>
              {tipContent && <InfoButton content={tipContent} />}
            </span>
          </div>
        )}
        <div className={`input-group form-autosuggest`}>
          <Autosuggest
            suggestions={this.props.suggestions}
            onSuggestionsFetchRequested={this.fetchSuggestionsWithDebounce}
            onSuggestionsClearRequested={this.props.clearSuggestions}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            renderSectionTitle={this.renderSectionTitle}
            getSectionSuggestions={this.getSectionSuggestions}
            shouldRenderSuggestions={() => true}
            inputProps={inputProps}
            onSuggestionSelected={this.handleSelection}
          />
          {search && (
            <span className="input-group-btn">
              <button
                className="btn btn-outline-secondary"
                type="submit"
                tabIndex={-1}
                style={{
                  border: '1px solid #ced4da',
                  borderLeft: 0,
                  zIndex: 0,
                  padding: '18px 25px',
                }}
              >
                {isPerformingSearch ? (
                  <i className="fal fa-spinner" />
                ) : (
                  <i className="fal fa-search" />
                )}
              </button>
            </span>
          )}
        </div>
        {touched && error && (
          <h6 className="text-danger small text-justify" style={{ marginTop: '5px' }}>
            {error}
          </h6>
        )}
      </div>
    )
  }
}

export default withAutocomplete(SearchBoxWithSuggestions)



// WEBPACK FOOTER //
// ./src/components/ui/forms/SearchBoxWithSuggestionsFromNetwork.js